import {Layout, Menu} from "antd";
import "./index.css";
import {
    AppstoreOutlined,
    DatabaseOutlined,
    InfoOutlined,
    LeftOutlined,
    RightOutlined,
    TeamOutlined,
    UnlockOutlined,
    UserOutlined,
    FileDoneOutlined
} from "@ant-design/icons";
import React from "react";
import SubMenu from "antd/lib/menu/SubMenu";
import AuthZButton from "../../components/AuthzButton";
import {useAppSideBarController} from "./controller";
import {SideBarOptions} from "./model";
import {IsFeatureEnabledOrNot} from "src/FeatureToggles/FeatureEnabledOrNot";
import {ToggleList} from "src/FeatureToggles/toggleList";

const AppSidebar = () => {
    const controller = useAppSideBarController();
    const isPoliciesUiToggleEnabled = IsFeatureEnabledOrNot(ToggleList.PoliciesUi)

    function userGroupMenuOptions() {
        let navigationSubMenus = [];
        const userGroupTypeNavList = controller.userGroupTypeNavList;
        for (const userGroupId in userGroupTypeNavList) {
            navigationSubMenus.push(
                <SubMenu
                    key={userGroupTypeNavList[userGroupId].uniqueName}
                    title={
                        <span
                            className="app-linkSpan"
                            style={{cursor: "pointer"}}
                        >
              {userGroupTypeNavList[userGroupId].titleName}
                        </span>
                    }
                    icon={<TeamOutlined style={{fontSize: 18, color: "white"}}/>}
                    onTitleClick={() => controller.onUserGroupSideBarClick(userGroupId)}
                />,
            );
        }
        return navigationSubMenus;
    }

    function renderSideBarCollapseButton() {
        return (
            <>
                <div className={"logo"}>
                    <Logo collapsed={controller.collapsed}/>
                </div>
                <div className="collapsible-btn-container">
                    <AuthZButton
                        icon={controller.collapsed ? <RightOutlined/> : <LeftOutlined/>}
                        onClick={controller.toggleCollapsed}
                        buttonClassName="collapsible-btn"
                        buttonShape="circle"
                        buttonStyle={{
                            marginLeft: controller.collapsed ? 63 : 202,
                            backgroundColor: "#5F9FAB",
                            color: "#FFFFFF",
                        }}
                    >
                    </AuthZButton>
                </div>
            </>
        );
    }

    const renderInformationAssetsMenu = () => {
        if (controller.shouldRenderInformationAssetsMenuOption()) {
            return (
                <SubMenu
                    key={SideBarOptions.INFORMATION_ASSETS}
                    icon={<DatabaseOutlined style={{fontSize: 18, color: "white"}}/>}
                    title={
                        <span
                            className={"app-linkSpan"}
                            style={{cursor: "pointer"}}
                        >
              Information Assets
                        </span>
                    }
                    onTitleClick={controller.onInformationAssetSideBarClick}
                />
            );
        }
    };

    const renderUserGuideMenu = () => {
        if (controller.shouldRenderUserGuideMenuOption()) {
            return (
                <SubMenu
                    key={SideBarOptions.USER_GUIDE}
                    icon={<InfoOutlined style={{fontSize: 18, color: "white"}}/>}
                    title={
                        <span
                            className={"app-linkSpan"}
                            style={{cursor: "pointer"}}
                        >
              User Guide
                        </span>
                    }
                    onTitleClick={controller.onUserGuideSideBarClick}
                />
            );
        }
    };

    const renderUsersMenu = () => {
        return (
            <SubMenu
                key={SideBarOptions.USERS}
                icon={<UserOutlined style={{fontSize: 18, color: "white"}}/>}
                title={
                    <span
                        className={"app-linkSpan"}
                        style={{cursor: "pointer"}}
                    >
            Users
                    </span>
                }
                onTitleClick={controller.onUsersSideBarClick}
            />
        );
    };

    const renderApplicationsMenu = () => {
        return (
            <SubMenu
                key={SideBarOptions.APPLICATIONS}
                icon={<AppstoreOutlined style={{fontSize: 18, color: "white"}}/>}
                title={
                    <span
                        className={"app-linkSpan"}
                        style={{cursor: "pointer"}}
                    >
            Access Reviews
                    </span>
                }
                onTitleClick={controller.onApplicationsSideBarClick}
            >
            </SubMenu>
        );
    };

    const renderPoliciesMenu = () => {
        return (
            <SubMenu
                key={SideBarOptions.POLICIES}
                icon={<FileDoneOutlined style={{fontSize: 18, color: "white"}}/>}
                title={
                    <span
                        className={"app-linkSpan"}
                        style={{cursor: "pointer"}}
                    >
            Policies
                    </span>
                }
                onTitleClick={controller.onPoliciesSideBarClick}
            >
            </SubMenu>
        );
    };

    function renderSideBarMenus() {
        return (
            <Menu
                mode={"inline"}
                defaultSelectedKeys={[controller.defaultKey]}
                selectedKeys={[controller.getSelectedMenuKey()]}
                style={{fontSize: 16, backgroundColor: "#173D4D", color: "#FFFFFF"}}
            >
                {renderUsersMenu()}
                {renderApplicationsMenu()}
                {userGroupMenuOptions()}
                {renderInformationAssetsMenu()}
                {isPoliciesUiToggleEnabled && (
                    <>{renderPoliciesMenu()}</>
                )}
                {renderUserGuideMenu()}
            </Menu>
        );
    }

    return (
        <Layout.Sider
            className={"appSidebar"}
            width={"217px"}
            collapsed={controller.collapsed}
        >
            {renderSideBarCollapseButton()}
            {renderSideBarMenus()}
        </Layout.Sider>
    );
};

const Logo = (props) => {
    return (
        <div className={"logo-content"}>
            <UnlockOutlined style={{marginLeft: props.collapsed ? 10 : 0}}/>
            {!props.collapsed && (
                <span style={{marginLeft: 12, fontSize: 21, fontWeight: 600}}>NEO AuthZ</span>
            )}
        </div>
    );
};

export default AppSidebar;
